import { render, staticRenderFns } from "./CanvasJSVueComponent.vue?vue&type=template&id=264634ca&"
import script from "./CanvasJSVueComponent.vue?vue&type=script&lang=js&"
export * from "./CanvasJSVueComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports